import { FunctionComponent, useContext } from "react";
import { ReactReduxContext } from "react-redux";

import { useIsFeatureActive } from "@/utils/useIsFeatureActive";
import { FeaturesCodes } from "@/pages/Private/pages/Users/enum/codes";

import { HelpLauncherButton } from "./HelpLauncherButton";
import { useRegisterHeaderLauncher } from "./helpLauncherRegistry";

const HeaderHelpLauncher: FunctionComponent = () => {
	const isActive = useIsFeatureActive(FeaturesCodes.HELP_CENTER);

	// Announce it while it is on screen, so the pinned fallback for header-less pages stands down.
	useRegisterHeaderLauncher(Boolean(isActive));

	if (!isActive) {
		return null;
	}

	return <HelpLauncherButton />;
};

/**
 * Feature-gated help affordance for the page headers. `PageHeader`, `FeedTopbar`,
 * `ListContextHeader` and the List/Account title bars render it unconditionally in their
 * right-hand slot, so every main surface gets the same question-mark icon without per-page wiring.
 * Pages with no header bar of their own get the identical icon from `PinnedHelpLauncher`, pinned to
 * the same top-right spot.
 *
 * The Redux-context guard makes the component a silent no-op when no store is mounted —
 * header components are unit-tested with plain `render()` (no providers), and the launcher
 * must not force every such spec to bootstrap the app store.
 */
export const HelpLauncher: FunctionComponent = () => {
	const reduxContext = useContext(ReactReduxContext);

	if (!reduxContext) {
		return null;
	}

	return <HeaderHelpLauncher />;
};
